module.exports = __webpack_public_path__ + "img/document-file-icon.89f11cea.png";